import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-booking-button',
  templateUrl: './booking-button.component.html',
  styleUrls: ['./booking-button.component.css']
})
export class BookingButtonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
